import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: 'flex',
    marginTop: 16,
    justifyContent: 'center',
  },
  bottomBarIncompleteOrdersContent: {
    zIndex: 10,
    backgroundColor: theme.palette.background.default,
    padding: 8,
    borderRadius: 32,
    height: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  title: {
    width: 260,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 18,
  },
  charts: {
    display: 'flex',
    height: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  individualChartContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 8,
  },
  individualChartLabel: {
    marginBottom: 16,
  },
  subtitle: {
    height: 40,
    textAlign: 'center',
    textTransform: 'capitalize',
    fontWeight: 300,
    fontSize: 12,
  },
  mobileCharts: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mobileIndividualChartContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: 0,
  },
}));
